module.exports = __webpack_public_path__ + "img/user.369ad9d6.svg";